export const SOMETHING_WRONG_TITLE = 'COMMON.SOMETHING-WRONG-TITLE';
export const SOMETHING_WRONG_MESSAGE = 'COMMON.SOMETHING-WRONG-MESSAGE';
export const LOGIN = 'COMMON.LOGIN';
export const NO_DATA = 'COMMON.NO-DATA';
export const DOWNLOAD_CSV = 'COMMON.DOWNLOAD-CSV';
export const UPDATED_DATA = 'COMMON.UPDATED-DATA';
export const DATA_NOT_RETRIEVED = 'COMMON.DATA-NOT-RETRIEVED';
export const CLOSE_TEXT = 'COMMON.CLOSE-TEXT';
export const AMOUNT_TEXT = 'COMMON.AMOUNT-TEXT';
export const PERCENTAGE = 'COMMON.PERCENTAGE';
export const SESSION_CLOSED = 'COMMON.SESSION-CLOSED';
export const CLOSE_SESSION = 'COMMON.CLOSE-SESSION';
export const SUMMARY_PAGE_TITLE = 'COMMON.SUMMARY-PAGE-TITLE';
export const TRANSACTIONS_PAGE_TITLE = 'COMMON.TRANSACTIONS-PAGE-TITLE';
export const TRANSACTIONS_DETAIL_PAGE_TITLE =
  'COMMON.TRANSACTION-DETAIL-PAGE-TITLE';
export const PERMISSIONS_PAGE_TITLE = 'COMMON.PERMISSIONS-PAGE-TITLE';
export const USERS_PAGE_TITLE = 'COMMON.USERS-PAGE-TITLE';
export const METRICS_PAGE_TITLE = 'COMMON.METRICS-PAGE-TITLE';
export const NEW_LINK_PAGE_TITLE = 'COMMON.NEW-LINK-PAGE-TITLE';
export const ADMIN_METRICS_PAGE_TITLE = 'COMMON.ADMIN-METRICS-PAGE-TITLE';
export const NEW_DASHBOARD_PAGE_TITLE = 'COMMON.NEW-DASHBOARD-PAGE-TITLE';
export const UPDATE_PAYMENT_METHOD_PAGE_TITLE =
  'COMMON.UPDATE-PAYMENT-METHOD-PAGE-TITLE';
export const DATE_TEXT = 'COMMON.DATE-TEXT';
export const TRX_STATUS: any = {
  approved: 'TRANSACTION-STATUS.approved',
  blocked: 'TRANSACTION-STATUS.blocked',
  challenge: 'TRANSACTION-STATUS.challenge',
  created: 'TRANSACTION-STATUS.created',
  expired: 'TRANSACTION-STATUS.expired',
  denied: 'TRANSACTION-STATUS.denied',
  in_progress: 'TRANSACTION-STATUS.in_progress',
  'in progress': 'TRANSACTION-STATUS.in progress',
  refunded: 'TRANSACTION-STATUS.refunded',
  reversed: 'TRANSACTION-STATUS.reversed',
  undefined: 'TRANSACTION-STATUS.undefined',
  used: 'TRANSACTION-STATUS.used',
  anothers: 'TRANSACTION-STATUS.anothers',
  other: 'TRANSACTION-STATUS.other',
};

export function i18nTrxStatus(statuses: string[] = []) {
  return statuses.map((status) => TRX_STATUS[status] as string);
}

// NEW-LINK: payment link form and transaction summary
export const NEW_LINK_CURRENCY_TEXT = 'NEW-LINK.CURRENCY-TEXT';
export const NEW_LINK_CURRENCY_CONFIG_MISSING =
  'NEW-LINK.CURRENCY-CONFIG-MISSING';
export const NEW_LINK_SUBTOTAL_TEXT = 'NEW-LINK.SUBTOTAL-TEXT';
export const NEW_LINK_TYPE_PAYMENT_ALERT_TITLE =
  'NEW-LINK.TYPE-PAYMENT-ALERT.TITLE';
export const NEW_LINK_TYPE_PAYMENT_ALERT_MESSAGE =
  'NEW-LINK.TYPE-PAYMENT-ALERT.MESSAGE';
export const NEW_LINK_SUMMARY_CLIENT_TEXT = 'NEW-LINK.SUMMARY.CLIENT-TEXT';
export const NEW_LINK_SUMMARY_EXTRA_CHARGES_TEXT =
  'NEW-LINK.SUMMARY.EXTRA-CHARGES-TEXT';
export const NEW_LINK_SUMMARY_PAYMENT_MODE_TEXT =
  'NEW-LINK.SUMMARY.PAYMENT-MODE-TEXT';
export const NEW_LINK_SUMMARY_PAYMENT_MODE_CASH =
  'NEW-LINK.SUMMARY.PAYMENT-MODE-CASH';
export const NEW_LINK_SUMMARY_PAYMENT_MODE_INSTALLMENTS =
  'NEW-LINK.SUMMARY.PAYMENT-MODE-INSTALLMENTS';
export const NEW_LINK_SUMMARY_NOT_SET_TEXT = 'NEW-LINK.SUMMARY.NOT-SET-TEXT';
